import { useHistory, useLocation } from 'react-router-dom';
import styles from './SuperCourses.module.scss';
import CustomizeUnits from 'src/components/customize-units/CustomizeUnits';
import { CourseContentType, UnitContentFragment, useSaveProgramUnitsMutation, useSaveReelsProgramMutation } from '@api/graphql-codegen'
import { useCallback } from 'react';
import { countryOptions } from '@src/constants';
import { useToast } from '@src/hooks/useToast';

export type SaveReelInput = {
  id: string;
  position: number;
  programId: string;
  type: CourseContentType;
}

function SuperCourses() {
  const { state: { program: course } } = useLocation<{ program: any }>();
  const history = useHistory();
  const { successToast } = useToast();

  const [saveProgramUnits, {loading: saving}] = useSaveProgramUnitsMutation({
    onCompleted(data) {
      if(data.saveProgramUnits) {
        successToast("Units are saved successfully!");
      }
      history.goBack();
    },
  });
  const [saveReelsProgram, {loading: saving1}] = useSaveReelsProgramMutation({
    onCompleted(data) {
      if (data.saveReel) {
        successToast("OP Reel is saved successfully!");
        history.goBack();
      }
    }
  })

  const handleOpenNew = useCallback((primary: UnitContentFragment[], additional: UnitContentFragment[], primaryOPReelContents?: any[]) => {
    const gradeunits = primary.map(unit => {
      return unit.id
    })
    const additionunits = additional.map(unit => {
      return unit.id
    })
    const courseContents = (primaryOPReelContents || []).map((content, index) => {
      return {
        id: content.id,
        programId: course.id,
        type: content.type,
        position: index + 1
      }
    })
    if (courseContents.length > 0 && course.country === countryOptions[1].label) {  // Australia Course
      saveReelsProgram({
        variables: {
          input: courseContents,
        }
      })
    } else {
      course && saveProgramUnits({
        variables: {
          input: {
            programId: course.id,
            primary: gradeunits,
            additional: additionunits
          }
        },
      });
    }

  }, [course, saveProgramUnits, saveReelsProgram]);

  const handleCancel = () => {
    history.goBack();
  };

  return (
    <>
      <div className={styles.unitView}>
        <CustomizeUnits
          handleOpenNew={handleOpenNew}
          handleCancel={handleCancel}
          type="course"
          course={course}
          isDisabled={saving || saving1}
        />
      </div>
    </>
  );
}

export default SuperCourses;
